module.exports = __webpack_public_path__ + "static/chp-ad-1-c366ff74212e3123672b12b0a3dbad9e.jpg";